






















import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import PersonData from '@/ts/PersonData';
import IdentityData from '@/ts/IdentityData';

@Component
export default class UserProfileButton extends Vue {
    constructor() {
        super();
    }

    get user(): PersonData {
        return this.$store.getters['User/getUser'];
    }

    get identities(): IdentityData[] {
        return this.$store.getters['Identities/getIdentities'];
    }

    public showProfile() {
        if (this.user.isTenant) {
            this.$router.push({
                name: 'user-profile',
            });
        } else {
            this.$store.commit(Mutations.SET_OVERLAY_VISIBILITY, {
                overlay: 'accountSwitcherVisibility',
                visibility: true,
            });
        }
    }

    private mobileLogOut() {
        this.$store.dispatch(Actions.LOG_OUT);
    }
}
